module.exports = __webpack_public_path__ + "static/media/infoJumbo2.2e38d968.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/aerolift/images/infoJumbo2.jpg
// module id = 531
// module chunks = 0